export default "__VITE_ASSET__woabMSxx__"